import { render, staticRenderFns } from "./daySixtyTable.vue?vue&type=template&id=fcd24c8a&scoped=true&"
import script from "./daySixtyTable.vue?vue&type=script&lang=js&"
export * from "./daySixtyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd24c8a",
  null
  
)

export default component.exports